import type { HTMLAttributes } from 'react';

import { Wordmark } from '@/components/brand/Wordmark';

export interface MHWordmarkProps extends HTMLAttributes<HTMLSpanElement> {
  /**
   * @deprecated The wordmark is always `mindhunters` (ADR-001). This prop is
   * retained only for call-site compatibility and is ignored.
   */
  label?: string;
}

/**
 * MHWordmark — thin compatibility shim over the canonical <Wordmark>.
 *
 * The brand wordmark has a SINGLE source of truth: `components/brand/Wordmark`
 * (Fraunces italic 700 lowercase, ADR-001). This shim keeps the legacy
 * `src/components/mh` barrel export working without re-declaring the font.
 */
export function MHWordmark({ label: _label, className, ...props }: MHWordmarkProps) {
  return <Wordmark className={className} {...props} />;
}
